// extracted by mini-css-extract-plugin
module.exports = {"header":"Disclaimer_header__PLJJm","content":"Disclaimer_content__B_Q4J","textAlignCenter":"Disclaimer_textAlignCenter__yWE4e"};